// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"346":"0f8ce6f7","633":"6c2836ca","816":"cef62a0c"}[chunkId] + ".chunk.js";
};